import { API_URL } from "./config";

const baseUrl = API_URL;

//GET/api/v1/categories
export const fetchCategories = async (lang) => {
  try {
    const response = await fetch(`${baseUrl}/api/v1/categories`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        lang: lang || "en",
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }

}
